import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BreadcrumbsLayout, BreadcrumbsSeparator, BreadcrumbsItem } from '../Breadcrumbs';

const MyGalleriesBreadcrumbs: FC<{}> = () => {
  const { t } = useTranslation();
  return (
    <BreadcrumbsLayout>
      <BreadcrumbsItem
        isRoot
        label={t('studio.header.tabs.published')}
        href={Url.studio({ section: 'published' })}
      />
      <BreadcrumbsSeparator />
      <BreadcrumbsItem label={t('studio.header.myGalleries')} />
    </BreadcrumbsLayout>
  );
};
MyGalleriesBreadcrumbs.displayName = 'MyGalleriesBreadcrumbs';

export default MyGalleriesBreadcrumbs;
